import { Dialog } from '@/components/ui/dialog';

export type InfoTopic = 'editEmail' | 'localPositions' | 'travelPositions' | 'otherStates';

const TITLES: Record<InfoTopic, string> = {
  editEmail: 'Edit email address',
  localPositions: 'Local Positions',
  travelPositions: 'Travel Positions',
  otherStates: 'More information',
};

export function InfoDialog({
  topic,
  onClose,
}: {
  topic: InfoTopic | undefined;
  onClose: () => void;
}) {
  return (
    <Dialog
      open={topic !== undefined}
      onClose={onClose}
      title={topic ? TITLES[topic] : ''}
      hideTitle
    >
      <div className="stack">{topic && BODIES[topic]}</div>
    </Dialog>
  );
}

const BODIES: Record<InfoTopic, React.ReactNode> = {
  editEmail: (
    <>
      <h3>Contact us to edit your email address</h3>
      <hr className="divider" />
      <p>
        Changing the email address associated with your MAS account requires support from one of our
        team members. Email us at{' '}
        <a href="mailto:help@masmedicalstaffing.com">help@masmedicalstaffing.com</a>, and we&apos;ll
        be happy to assist you.
      </p>
    </>
  ),
  localPositions: (
    <>
      <h3>Work, how YOU want it!</h3>
      <p>
        MAS has local work opportunities that put you in control. Like the consistency of working at
        the same facility each shift? Our local contract openings give you the chance to work a
        multi-week assignment at one of our partner facilities. Want total flexibility and control
        over your schedule? Pick up individual per diem shifts at facilities across our network in
        your local area.
      </p>
      <p>
        After you&apos;re hired, you&apos;ll receive access to Maestra, our caregiver mobile app,
        along with a dedicated support team to find the local opportunities that best meet your
        career, pay, and schedule needs. Build your ideal schedule - with day, evening, and night
        shifts available 7 days a week, 365 days a year.
      </p>
    </>
  ),
  travelPositions: (
    <>
      <h3>Ready for your next adventure?</h3>
      <p>
        You tell us where you want to go and what you&apos;re looking for - we&apos;ll help you get
        there. With our travel healthcare jobs, you always have the support you need every step of
        the way.
      </p>
      <p>
        Unlike a traditional healthcare job, travel healthcare offers exciting opportunities to meet
        new people and experience new locations, all while using your skills to earn great pay. Each
        travel assignment consists of a multi-month contract, most often at a single facility, in
        cities and towns across the country. The assignment can also include a generous housing
        stipend and assistance in finding a place to live while working and exploring your new
        travel location.
      </p>
      <p>
        Every MAS traveler is paired with a support team who are available throughout your
        assignment, to ensure your healthcare adventure goes smoothly. Once your travel contract is
        nearing an end, our staff will be ready to find you your next travel assignment, or help you
        transition to one of MAS&apos; local opportunities back home.
      </p>
    </>
  ),
  otherStates: (
    <>
      <h3>Are you interested in working in any other states?</h3>
      <p>
        Upon hire, MAS can assist you in obtaining licensure in a state where you would like to
        work.
      </p>
    </>
  ),
};
